import React, { useMemo } from 'react';
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';
import { View, useWindowDimensions } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { useAppTheme } from '../contexts/ThemeContext';
import { EventsScreen } from '../screens/main/EventsScreen';
import { MarketplaceScreen } from '../screens/main/MarketplaceScreen';
import type { CommunityTopTabParamList } from './types';

const TopTab = createMaterialTopTabNavigator<CommunityTopTabParamList>();

export function CommunityNavigator() {
  const { isDark } = useAppTheme();
  const insets = useSafeAreaInsets();
  const { width: windowWidth } = useWindowDimensions();

  const tabScreenOptions = useMemo(
    () => ({
      tabBarActiveTintColor: isDark ? '#fafafa' : '#18181b',
      tabBarInactiveTintColor: isDark ? '#a1a1aa' : '#71717a',
      tabBarIndicatorStyle: {
        backgroundColor: isDark ? '#fafafa' : '#18181b',
        height: 2,
        borderRadius: 2,
      },
      tabBarLabelStyle: {
        fontWeight: '600' as const,
        fontSize: 13,
        textTransform: 'none' as const,
      },
      tabBarItemStyle: { flex: 1 },
      tabBarStyle: {
        backgroundColor: isDark ? '#000000' : '#ffffff',
        elevation: 4,
        shadowOpacity: 0,
        borderBottomWidth: 1,
        borderBottomColor: isDark ? '#27272a' : '#e4e4e7',
        zIndex: 10,
      },
      /** PagerView ölçüsü / sekme göstergesi kayması (kaydırınca çizgi takılmıyordu). */
      lazy: false,
    }),
    [isDark],
  );

  const topBg = isDark ? '#000000' : '#ffffff';

  return (
    <View
      pointerEvents="box-none"
      style={{ flex: 1, backgroundColor: topBg, paddingTop: insets.top }}>
      <TopTab.Navigator
        initialLayout={{ width: windowWidth, height: 0 }}
        screenOptions={tabScreenOptions}>
        <TopTab.Screen
          name="CommunityEvents"
          component={EventsScreen}
          options={{ title: 'Buluşmalar' }}
        />
        <TopTab.Screen
          name="CommunityMarketplace"
          component={MarketplaceScreen}
          options={{ title: 'Pazar Yeri' }}
        />
      </TopTab.Navigator>
    </View>
  );
}
